export default __webpack_public_path__ + "logo-dark.d398978dfdeb88a3a61ae97c1bf903bf.png";